export default __webpack_public_path__ + "static/professor-7-0da0768ba71302973e9641149403ca78.png";